import React, { useState, createContext, useEffect } from 'react'
import { myAtSavedAdvertListQuery } from '../components/search-listing-save-advert/query/advert-save-list.fed.query'
import { useSecureFederatedQuery as useQuery } from '@at/sauron-platform-graphql'
import { VehicleChannel } from '../__generated__/fed-graphql-types'
import {
    SavedAdvertsQuery_Query,
    SavedAdvertsQuery_user_User_savedAdverts_SavedAdvertsResult_results_SavedAdvert,
    SavedAdvertsQueryVariables,
} from '../components/search-listing-save-advert/query/__generated__/advert-save-list.fed.query'
import { useChannel } from '../hooks/use-abtest.hook'
import { useUserState } from '@at/connected-signin'

type CreateSavedAdvertsContextType = {
    savedAdvertsList: string[]
    savedAdvertsListError: boolean
    savedAdvertsListLoading: boolean
    setSavedAdvertsList: (savedAdverts: string[]) => void
}

export const SavedAdvertsQueryContext = createContext<CreateSavedAdvertsContextType>({
    savedAdvertsList: [],
    savedAdvertsListError: false,
    savedAdvertsListLoading: false,
    setSavedAdvertsList: () => {},
})
SavedAdvertsQueryContext.displayName = 'SaveAdvertContext'

export const SavedAdvertsContextProvider = ({ children }: React.PropsWithChildren<object>) => {
    const channel = useChannel()
    const [userState] = useUserState()
    const [savedAdvertsList, setSavedAdvertsList] = useState<string[]>([])

    /** Fetch save adverts if user is logged in */
    const { data, error, loading } = useQuery<SavedAdvertsQuery_Query, SavedAdvertsQueryVariables>(
        myAtSavedAdvertListQuery,
        {
            variables: { channel: channel as unknown as VehicleChannel },
            skip: !userState.userSignedIn,
        }
    )

    useEffect(() => {
        if (!data) return

        setSavedAdvertsList(
            data?.user?.savedAdverts.results.map(
                (advert: SavedAdvertsQuery_user_User_savedAdverts_SavedAdvertsResult_results_SavedAdvert) => advert.id
            ) || []
        )
    }, [data])

    const savedAdvertsValues = {
        savedAdvertsList,
        savedAdvertsListError: !!error,
        savedAdvertsListLoading: loading,
        setSavedAdvertsList,
    }

    return <SavedAdvertsQueryContext.Provider value={savedAdvertsValues}>{children}</SavedAdvertsQueryContext.Provider>
}
